<template>
  <div id="app">
    <Pagej />
  </div>
</template>
<script>
import Pagej from '@/views/Health';
export default {
  name: 'App',
  components: { Pagej },
};
</script>
